import moment from 'moment';
import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import {
  CLEAR_AUTOSAVE,
  DELETE_CLIENT_FAILURE,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  FETCH_CLIENT_FAILURE,
  FETCH_CLIENT_REQUEST,
  FETCH_CLIENT_SUCCESS,
  GET_NO_SHOWS_FAILURE,
  GET_NO_SHOWS_REQUEST,
  GET_NO_SHOWS_SUCCESS,
  GET_SCHEDULED_BOOKING_FAILURE,
  GET_SCHEDULED_BOOKING_REQUEST,
  GET_SCHEDULED_BOOKING_SUCCESS,
  REMOVE_EDIT_CLIENT,
} from 'clientProfile/constants';

export const getScheduledBooking = (salonId, clientId, page) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/client/${clientId}/scheduled/?page=${String(page ?? 1)}`,
    authenticated: true,
    types: [GET_SCHEDULED_BOOKING_REQUEST, GET_SCHEDULED_BOOKING_SUCCESS, GET_SCHEDULED_BOOKING_FAILURE],
  },
});

export const getNoShows = (salonId, clientId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `metrics/appointment/client/noshow/${salonId}/${clientId}/${moment()
      .subtract(1, 'years')
      .toISOString()}/${moment().toISOString()}/`,
    authenticated: true,
    types: [GET_NO_SHOWS_REQUEST, GET_NO_SHOWS_SUCCESS, GET_NO_SHOWS_FAILURE],
  },
});

export const fetchClient = (salonId, data) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/client/${data.id}/`,
    authenticated: true,
    types: [FETCH_CLIENT_REQUEST, FETCH_CLIENT_SUCCESS, FETCH_CLIENT_FAILURE],
    params: { salonId, data, method: 'GET' },
    config: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  },
});

export const deleteClient = (salonId, data) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/client/${data.id}/`,
    authenticated: true,
    types: [DELETE_CLIENT_REQUEST, DELETE_CLIENT_SUCCESS, DELETE_CLIENT_FAILURE],
    params: { salonId, data, method: 'DELETE' },
    config: {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
    meta: { analytics: EventTypes.track },
  },
});

// FIXME: seems unused, delete it
export const clearAutosave = () => ({ type: CLEAR_AUTOSAVE, meta: { analytics: EventTypes.track } });

export const removeEditClient = () => ({ type: REMOVE_EDIT_CLIENT });
